import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { format } from "date-fns";
// Named importy zamiast `import * as locale` — namespace-barrel wciągał
// wszystkie ~100 locale do bundla; używamy tylko pl + fallback enUS.
import { pl, enUS } from "date-fns/locale";

const lang = "pl";

const localesByLang: Record<string, typeof enUS> = { pl, enUS };

const getDateFnsLocale = (lang: string) => {
  return localesByLang[lang] || enUS;
};
type FormFieldDatePickerPropsType<T extends FieldValues = FieldValues> = {
  form: UseFormReturn<T>;
  label: string;
  name: string;
  description?: string;
  minDate?: Date;
  maxDate?: Date;
};

function FormFieldDatePicker({
  form,
  description,
  label,
  name,
  minDate = new Date("1900-01-01"),
  maxDate = new Date("2030-01-01"),
}: FormFieldDatePickerPropsType) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabel>{label}</FormLabel>
          <Popover modal>
            <PopoverTrigger asChild>
              <FormControl>
                <Button className={cn("w-[240px] pl-3 text-left font-normal", !field.value && "text-muted-foreground")}>
                  {field.value ? (
                    format(field.value, "d MMMM yyyy", { locale: getDateFnsLocale(lang) })
                  ) : (
                    <span>Wybierz date</span>
                  )}
                  <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                </Button>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={field.value}
                onSelect={field.onChange}
                disabled={(date) => date > maxDate || date < minDate}
                initialFocus
                locale={getDateFnsLocale(lang)}
              />
            </PopoverContent>
          </Popover>
          <FormDescription>{description}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default FormFieldDatePicker;
